import React  from 'react';


import 'antd/dist/antd.css';
import {Card ,Divider ,Carousel} from 'antd';

import { BellOutlined } from '@ant-design/icons';

 const MyEvents =(props) =>{


    return (
        <>
         <Card>
            <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;Events</Divider>
             
                <Carousel autoplay>
    <div >
    <Card
 
    
    hoverable={true}
     title="Event 1"
    >Card content
       
    </Card>
    
    </div>
    <div>
    <Card
  
 hoverable={true}
  title="Event 2"
 >Card content
    
 </Card>
    </div>
    <div>
    <Card
 
    
 hoverable={true}
  title="Event 3"
 >Card content
    
 </Card>
    </div>

  </Carousel>

            </Card>
          
            
        </>
    )
}
export default MyEvents